module.exports = __webpack_public_path__ + "static/media/partner-hiperlink.d65b7301.png";